import * as React from 'react';

function SvgSearchSidebar(props) {
  return (
    <svg {...props} width={24} height={24} viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd" stroke={props.color} strokeWidth={2}>
        <circle cx={10} cy={10} r={7} />
        <path strokeLinecap="round" d="M15.5 15.5L21 21" />
      </g>
    </svg>
  );
}

export default SvgSearchSidebar;
